import { get, post, patch } from '../HttpService';

export class WorkingHourService {
    static list = (queryData = {}, config = {}) => {
        return get(`/v1/admin/working_hours/`, queryData, config);
    }

    static update = (queryData = {}, config = {}) => {
        return patch(`/v1/admin/working_hours/${queryData.id}/`, queryData, config);
    }
    
}